// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"41":"error","620":"collections","767":"details","874":"men"}[chunkId] + "." + {"41":"21d38efd","620":"1ca1e208","767":"839b4044","874":"0972ea0b"}[chunkId] + ".css";
};